import { Box, Grid, Typography } from "@mui/material";
import Image from "next/image";
import { useTheme } from "@cellectenergy/cellect-react-components";
import { ZShapeImageWrapper } from "./zShapeAbout.styles";
import { useTranslation } from "react-i18next";

const ZShape = () => {
  const theme = useTheme();
  const { t } = useTranslation("global");

  const items = [
    {
      title: t("about.zShape.vision.title"),
      description: t("about.zShape.vision.description"),
      image: "/assets/about/vision.webp",
    },
    {
      title: t("about.zShape.mission.title"),
      description: t("about.zShape.mission.description"),
      image: "/assets/about/mission.webp",
    },
    {
      title: t("about.zShape.approach.title"),
      description: t("about.zShape.approach.description"),
      image: "/assets/about/approach.webp",
    },
  ];

  return (
    <Box marginTop={{ xs: "5rem", lg: "7.5rem" }}>
      {items.map((item, index) => (
        <Box
          key={item.title}
          padding={{
            xs: "0 1rem 3rem 1rem",
            md: "0 1.5rem 3.5rem 1.5rem",
            lg: "0 2rem 4rem 2rem",
          }}
          sx={{
            backgroundColor:
              theme.palette.common.corporateColors.primary.midNightBlue,
          }}
          maxWidth={"1440px"}
          margin={"0 auto"}
          width={"100%"}
        >
          <Grid
            container
            rowGap={{ xs: "2rem", md: "0" }}
            columnSpacing={{ xs: "0", sm: "2rem", lg: "1rem" }}
          >
            <Grid
              order={{ xs: 1, sm: index === 1 ? 2 : 1 }}
              item
              xs={12}
              sm={6}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              paddingLeft={{
                lg: index === 1 ? "2rem !important" : "",
              }}
            >
              <ZShapeImageWrapper>
                <Image src={item.image} alt={item.title} fill={true} />
              </ZShapeImageWrapper>
            </Grid>

            <Grid
              order={{
                xs: 2,
                sm: index === 1 ? 1 : 2,
              }}
              item
              xs={12}
              sm={6}
              paddingLeft={{
                lg: index === 1 ? "" : "2rem !important",
              }}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={{
                  xs: ".5rem",
                  md: "1.5rem",
                }}
                justifyContent={"center"}
                alignItems={"flex-start"}
                height={"100%"}
              >
                <Typography
                  fontWeight={500}
                  variant="headline-medium"
                  align="left"
                  color={theme.palette.common.corporateColors.primary.white}
                >
                  {item.title}
                </Typography>
                <Typography
                  width={{ xs: "100%" }}
                  align="left"
                  variant="headline-small"
                  fontWeight={400}
                  color={theme.palette.common.corporateColors.primary.white}
                >
                  {item.description}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default ZShape;
